var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"justify-content-md-center m-0"},[_c('b-col',{attrs:{"lg":"6"}},[(_vm.isVideoConferencePost)?_c('div',[_c('EditVideoConference')],1):_c('div',[_c('CreateOrEditPost')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }